import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { postDataWithToken } from "../../services/PostDataService";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import PulseLoader from "react-spinners/PulseLoader";
import { useTheme } from "@mui/material/styles";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CardsIcon from "../../components/icons/CardsIcon";
import CloseIcon from "@mui/icons-material/Close";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { 
  Person as PersonIcon,
  Email as EmailIcon,
  CreditCard as CreditCardIcon,
  Star as StarIcon,
  Add as AddIcon
} from "@mui/icons-material";
import { InputAdornment, Divider } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  cardElementDesign: {
    // Add your custom styles for the CardElement here
    // For example, you can set the width, padding, border, etc.
    width: "100%",
    fontSize: "24px",
    padding: "8.5px 14px",
    border: "1px solid #ced4da",
    borderRadius: theme.shape.borderRadius,
  },
  formField: {
    marginBottom: "1.5rem",
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#016363",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#016363",
      },
    },
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "60px",
    height: "60px",
    backgroundColor: "#E5FFFD",
    borderRadius: "50%",
    marginBottom: "1rem",
  },
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    padding: "2rem 2rem 1rem 2rem",
    borderBottom: "1px solid #E5FFFD",
  },
  dialogContent: {
    padding: "2rem",
  },
  cancelButton: {
    borderRadius: "12px",
    textTransform: "none",
    fontWeight: 500,
    minWidth: "120px",
    borderColor: "#E5FFFD",
    color: "#016363",
    "&:hover": {
      borderColor: "#016363",
      backgroundColor: "#E5FFFD",
    },
  },
  addButton: {
    borderRadius: "12px",
    textTransform: "none",
    fontWeight: 600,
    minWidth: "140px",
    backgroundColor: "#016363",
    "&:hover": {
      backgroundColor: "#014a4a",
    },
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: "#F8F9FA",
    borderRadius: "12px",
    border: "1px solid #E5FFFD",
  },
}));

const CardForm = ({
  cardList,
  publicKey,
  intend,
  getCardList,
  handleAddCardClose,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const stripe = useStripe();
  const elements = useElements();
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardHolderEmail, setCardHolderEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [checked, setChecked] = useState(cardList.length > 0 ? false : true);
  const [succesMessageShow, setSuccesMessageShow] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let card = elements.getElement(CardElement);
    // console.log("card", card);

    stripe
      .confirmCardSetup(intend, {
        payment_method: {
          card: card,
          billing_details: { email: cardHolderEmail, name: cardHolderName },
        },
      })
      .then(function (result) {
        if (result.error) {
          setLoading(false);
          handleSnakbarOpen(result.error.message, "error");
        } else {
          // console.log("result", result);
          if (checked) {
            onSetDefaultCard(result?.setupIntent.payment_method);
          }
          setSuccesMessageShow(true);
          setTimeout(function () {
            getCardList();
            setCardHolderName("");
            setCardHolderEmail("");
            // handleSnakbarOpen("Card added Successfully.", "success");
            // handleAddCardClose();
            setLoading(false);
            // setSuccesMessageShow(false);
          }, 2500);
          //   setCardAsDefault(result.setupIntent.payment_method)
        }
      });
    // setLoading(false);
  };
  const onSetDefaultCard = async (cardId) => {
    let data = {
      storeId: admin_panel_user.selectedStoreId,
      cardId: cardId,
    };

    let response = await postDataWithToken(
      "setDefaultCard",
      data,
      admin_panel_user,
      logout
    );

    if (response.data.code === 200) {
      //   getCardList();
      //   handleSnakbarOpen(response.data.message, "success");
    } else {
      handleSnakbarOpen(response.data.message, "error");
    }
  };
  const cardNumberElementOptions = {
    style: {
      base: {
        fontSize: "16px",
        fontFamily: "Roboto, sans-serif",
        fontWeight: 400,
        fontSmoothing: "antialiased",
        // lineHeight: '45px',
      },
    },
    // placeholder: "Card Number",
  };

  // Focus on expiry field when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      if (elements) {
        const cardElement = elements.getElement(CardElement);
        if (cardElement) {
          // Focus on the card element
          cardElement.focus();
          
          // Try to navigate to the expiry field by simulating right arrow key
          // This should move the cursor to the expiry field
          setTimeout(() => {
            // Simulate right arrow key to move to expiry field
            const rightArrowEvent = new KeyboardEvent('keydown', {
              key: 'ArrowRight',
              code: 'ArrowRight',
              keyCode: 39,
              which: 39,
              bubbles: true
            });
            
            // Also try tab key as fallback
            const tabEvent = new KeyboardEvent('keydown', {
              key: 'Tab',
              code: 'Tab',
              keyCode: 9,
              which: 9,
              bubbles: true
            });
            
            // Dispatch both events
            document.dispatchEvent(rightArrowEvent);
            setTimeout(() => document.dispatchEvent(tabEvent), 50);
          }, 200);
        }
      }
    }, 1500); // Longer delay to ensure Stripe element is fully rendered

    return () => clearTimeout(timer);
  }, [elements]);

  return (
    <>
      {succesMessageShow ? (
        <>
          {/* <img
            src="./success.gif"
            alt="success"
            style={{ display: "block", margin: "auto" }}
          /> */}
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            // sx={{ mb: 1 }}
          >
            <Grid item xs="auto"></Grid>
            <Grid item xs="auto">
              <IconButton
                variant="outlined"
                disableElevation
                onClick={handleAddCardClose}
                style={{
                  background: theme.palette.border.main,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Avatar
            sx={{
              width: 150,
              height: 150,
              bgcolor: `${theme.palette.primary.light}`,

              margin: "auto auto 10px auto",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
            >
              <path
                d="M6.66699 28.3334H45.0003"
                stroke={theme.palette.primary.main}
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20 55H26.6667"
                stroke={theme.palette.primary.main}
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M35 55H48.3333"
                stroke={theme.palette.primary.main}
                stroke-width="3"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M73.3337 36.7666V53.7C73.3337 65.4 70.367 68.3333 58.5337 68.3333H21.467C9.63366 68.3333 6.66699 65.4 6.66699 53.7V26.3C6.66699 14.6 9.63366 11.6666 21.467 11.6666H45.0003"
                stroke={theme.palette.primary.main}
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M55 20L60 25L73.3333 11.6666"
                stroke={theme.palette.primary.main}
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Avatar>
          <Typography
            variant="h3"
            color="primary.main"
            sx={{ textAlign: "center" }}
          >
            Successful
          </Typography>
          <Typography
            variant="h6"
            color="text.light"
            sx={{ textAlign: "center", mb: 5 }}
          >
            Your Card Is Successfully Added
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <Button
                fullWidth
                startIcon={<AddRoundedIcon />}
                style={{
                  minHeight: "37px",
                  textTransform: "none",
                  border: `1px solid ${theme.palette.text.light}`,
                  color: theme.palette.text.light,
                }}
                onClick={() => setSuccesMessageShow(false)}
              >
                {" "}
                Add New Card
              </Button>
            </Grid>
            <Grid item xs={7}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disableElevation
                onClick={handleSubmit}
                disabled
                style={{
                  minHeight: "37px",
                  textTransform: "none",
                  background: theme.palette.primary.main,
                  color: "#fff",
                }}
              >
                Thank you!
              </Button>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Box className={classes.dialogTitle}>
            <Box className={classes.iconContainer}>
              <AddIcon sx={{ color: "#016363", fontSize: "1.5rem" }} />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ color: "#016363", fontWeight: 600, margin: 0 }}>
                Add New Card
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", marginTop: "0.25rem" }}>
                Securely add a payment method to your account
              </Typography>
            </Box>
            <Box sx={{ marginLeft: "auto" }}>
              <IconButton
                variant="outlined"
                disableElevation
                onClick={handleAddCardClose}
                sx={{
                  background: theme.palette.border.main,
                  "&:hover": {
                    background: "#E5FFFD",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          <Box className={classes.dialogContent}>
            <Box sx={{ marginBottom: "2rem" }}>
              <TextField
                fullWidth
                label="Cardholder Name"
                value={cardHolderName}
                onChange={(e) => setCardHolderName(e.target.value)}
                className={classes.formField}
                placeholder="Enter the name on the card"
                required
                inputProps={{ maxLength: 20 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon sx={{ color: "#016363" }} />
                    </InputAdornment>
                  ),
                }}
                helperText="Enter the name exactly as it appears on the card"
              />
            </Box>
            
            <Box sx={{ marginBottom: "2rem" }}>
              <TextField
                fullWidth
                label="Email Address"
                type="email"
                value={cardHolderEmail}
                onChange={(e) => setCardHolderEmail(e.target.value)}
                className={classes.formField}
                placeholder="Enter your email address"
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon sx={{ color: "#016363" }} />
                    </InputAdornment>
                  ),
                }}
                helperText="We'll use this for payment notifications"
              />
            </Box>
            
            <Box sx={{ marginBottom: "2rem" }}>
              <Typography variant="body1" sx={{ color: "#016363", fontWeight: 500, marginBottom: "0.5rem" }}>
                Card Information *
              </Typography>
              <Box sx={{ 
                border: "1px solid #E5FFFD", 
                borderRadius: "12px", 
                padding: "0.75rem",
                "&:hover": {
                  borderColor: "#016363",
                },
                "&:focus-within": {
                  borderColor: "#016363",
                }
              }}>
                <CardElement
                  className={classes.cardElementDesign}
                  options={cardNumberElementOptions}
                />
              </Box>
              <Typography variant="caption" sx={{ color: "#666", marginTop: "0.5rem", display: "block" }}>
                Enter your card number, expiry date, and CVC
              </Typography>
            </Box>
            
            <Box className={classes.checkboxContainer}>
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={checked} 
                    onChange={handleChange}
                    sx={{
                      color: "#016363",
                      "&.Mui-checked": {
                        color: "#016363",
                      },
                    }}
                  />
                }
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <StarIcon sx={{ color: "#016363", fontSize: "1rem" }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Set as default payment method
                    </Typography>
                  </Box>
                }
              />
            </Box>

            <Divider sx={{ margin: "2rem 0" }} />
            
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
                className={classes.addButton}
                fullWidth
                startIcon={loading ? <PulseLoader color="white" loading={loading} size={10} speedMultiplier={0.5} /> : <AddIcon />}
                sx={{
                  minHeight: "48px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {loading ? "Adding Card..." : "Add New Card"}
              </Button>
              
              <Button
                variant="outlined"
                onClick={handleAddCardClose}
                className={classes.cancelButton}
                fullWidth
                startIcon={<CloseIcon />}
                sx={{
                  minHeight: "48px",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};

export default CardForm;
